import { useInstantSearch } from "react-instantsearch-hooks-web";

type Props = {
    children: JSX.Element;
    fallback: JSX.Element | null;
};

function SearchEmptyQueryBoundary({ children, fallback }: Props) {
    const { indexUiState } = useInstantSearch();

    if (!indexUiState.query) {
        return fallback;
    }

    return children;
}

export default SearchEmptyQueryBoundary;
